export default __webpack_public_path__ + "static/sam-0107910647b1e0abd45239e1789b2510.svg";